import React from "react";
import AutomationList from "../shared/components/AutomationList";
import { WORKFLOW_CATEGORY } from "../workflow/utils/enums";

const TaskManagerAutomation: React.FC = () => {
  return (
    <AutomationList
      workflowCategory={WORKFLOW_CATEGORY.TASK}
      title="Task Manager Automation"
      breadcrumb="Tasks"
      module="tasks"
    />
  );
};

export default TaskManagerAutomation;
